import { Text } from "@meditect/medibase-components";

export const SalesCannotCancelSaleWithInsufficientCashError = () => {
  return <Text>Solde en caisse insuffisant. Merci d'approvisionner la caisse.</Text>;
};
